module.exports = __webpack_public_path__ + "static/media/Piercing-mouth-dolphinbites.0796f72d.png";